import { Container } from '@dagensmat/carrot/Layout';
import ProducerSalesModuleStatistics from './ProducerSalesModuleStatistics';
import ProducerSalesModuleTopUp from './ProducerSalesModuleTopUp';
import ProducerSalesModuleReminder from './ProducerSalesModuleReminder';

const ProducerSalesModules = () => {
  return (
    <Container
      width="full"
      flex
      justify="flex-start"
      wrap="wrap"
      alignItems="stretch"
      gap="s"
      py="s"
    >
      <ProducerSalesModuleStatistics />
      <ProducerSalesModuleTopUp />
      <ProducerSalesModuleReminder />
    </Container>
  );
};
export default ProducerSalesModules;
